import { postRequest } from "../apiHelpers";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	getContractByKeyURL, getContractDetailURL, getExportRiskVehicleContract, getExportAgentCommission,
	cancelContractURL, getActiveLifePackageURL, registerCustomerURL, getLifeContractURL, editCustomerURL,
	claimLifeInsurnaceURL, getExportLifeContract, getExportVehicleContract,
	getActiveVehicleTypeURL,
	getActiveVehiclePackageURL,
	registerVehicleURL,
	getVehiclesContractURL,
	editVehiclesURL,
	callCancelContractVehicleURL,
	getCancelContractURL,
	approveCancelContractURL,
	getApproveContractURL,
	approveContractURL,
	getVehicleCaseIdiomsURL,
	addVehicleCaseIdiomsURL,
	updateVehicleCaseIdiomsURL,
	getVehicleCaseIdiomsByIdURL,
	getVehicleCaseIdiomsByContractURL,
	getVehicleCaseIdiomsAllByContractURL,
	deleteVehicleCaseIdiomsURL,
	resetVehicleCaseIdiomsURL,
	checkRenewURL,
	checkContractNumberURL,
	getPaymentURL,
	commissionDetailURL,
	approveDetailURL,
	commissionPayoutURL,
	createCommissionPayoutURL,
	commissionDetailByPayoutIdURL,
	approveOrRejectCommissionPayoutURL,
	exportVehicleContractPdfURL,
	getPaymentDDURL,
	getPaymentDetailURL,
	commissionDetailByAgentIdURL,
	updateStatusClameContractURL,
	getUserContractsURL,
	searchContractsForUserURL,
	attachContractToUserURL,
	detachContractFromUserURL
} from "../pathApi";

export const callGetContractByKey = createAsyncThunk(getContractByKeyURL, async (body) => {
	try {
		const response = await postRequest({ url: getContractByKeyURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetPaymentByContractNumber = createAsyncThunk(getPaymentURL, async (body) => {
	try {
		const response = await postRequest({ url: getPaymentURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetContractDetail = createAsyncThunk(getContractDetailURL, async (body) => {
	try {
		const response = await postRequest({ url: getContractDetailURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callCancelContract = createAsyncThunk(cancelContractURL, async (body) => {
	try {
		const response = await postRequest({ url: cancelContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportRiskVehicleContract = createAsyncThunk(getExportRiskVehicleContract, async (body) => {
	try {
		const response = await postRequest({ url: getExportRiskVehicleContract, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportAgentCommission = createAsyncThunk(getExportAgentCommission, async (body) => {
	try {
		const response = await postRequest({ url: getExportAgentCommission, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetActivePackage = createAsyncThunk(getActiveLifePackageURL, async (body) => {
	try {
		const response = await postRequest({ url: getActiveLifePackageURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetActiveVehicleType = createAsyncThunk(getActiveVehicleTypeURL, async (body) => {
	try {
		const response = await postRequest({ url: getActiveVehicleTypeURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetActiveVehiclePackage = createAsyncThunk(getActiveVehiclePackageURL, async (body) => {
	try {
		const response = await postRequest({ url: getActiveVehiclePackageURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const addVehicleContract = createAsyncThunk(registerVehicleURL, async (body) => {
	try {
		const response = await postRequest({ url: registerVehicleURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const addLifeContract = createAsyncThunk(registerCustomerURL, async (body) => {
	try {
		const response = await postRequest({ url: registerCustomerURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const editLifeContract = createAsyncThunk(editCustomerURL, async (body) => {
	try {
		const response = await postRequest({ url: editCustomerURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const editVehiclesContract = createAsyncThunk(editVehiclesURL, async (body) => {
	try {
		const response = await postRequest({ url: editVehiclesURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const getLifeContract = createAsyncThunk(getLifeContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getLifeContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const getVehiclesContract = createAsyncThunk(getVehiclesContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getVehiclesContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const reqClameLifeContract = createAsyncThunk(claimLifeInsurnaceURL, async (body) => {
	try {
		const response = await postRequest({ url: claimLifeInsurnaceURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportLifeContract = createAsyncThunk(getExportLifeContract, async (body) => {
	try {
		const response = await postRequest({ url: getExportLifeContract, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportVehicleContract = createAsyncThunk(getExportVehicleContract, async (body) => {
	try {
		const response = await postRequest({ url: getExportVehicleContract, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const cancelVehicleContract = createAsyncThunk(callCancelContractVehicleURL, async (body) => {
	try {
		const response = await postRequest({ url: callCancelContractVehicleURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetCancelContract = createAsyncThunk(getCancelContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getCancelContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callApproveCancelContract = createAsyncThunk(approveCancelContractURL, async (body) => {
	try {
		const response = await postRequest({ url: approveCancelContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetApproveContract = createAsyncThunk(getApproveContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getApproveContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const approveClameLifeContract = createAsyncThunk(approveContractURL, async (body) => {
	try {
		const response = await postRequest({ url: approveContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const updateStatusClameContract = createAsyncThunk(updateStatusClameContractURL, async (body) => {
	try {
		const response = await postRequest({ url: updateStatusClameContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callgetVehicleCaseIdioms = createAsyncThunk(getVehicleCaseIdiomsURL, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleCaseIdiomsURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callgetVehicleCaseIdiomsById = createAsyncThunk(getVehicleCaseIdiomsByIdURL, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleCaseIdiomsByIdURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callgetVehicleCaseIdiomsByContract = createAsyncThunk(getVehicleCaseIdiomsByContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleCaseIdiomsByContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callgetVehicleCaseIdiomsAllByContract = createAsyncThunk(getVehicleCaseIdiomsAllByContractURL, async (body) => {
	try {
		const response = await postRequest({ url: getVehicleCaseIdiomsAllByContractURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const addVehicleCaseIdioms = createAsyncThunk(addVehicleCaseIdiomsURL, async (body) => {
	try {
		const response = await postRequest({ url: addVehicleCaseIdiomsURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const updateVehicleCaseIdioms = createAsyncThunk(updateVehicleCaseIdiomsURL, async (body) => {
	try {
		const response = await postRequest({ url: updateVehicleCaseIdiomsURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const cancelVehicleCaseIdioms = createAsyncThunk(deleteVehicleCaseIdiomsURL, async (body) => {
	try {
		const response = await postRequest({ url: deleteVehicleCaseIdiomsURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const resetVehicleCaseIdioms = createAsyncThunk(resetVehicleCaseIdiomsURL, async (body) => {
	try {
		const response = await postRequest({ url: resetVehicleCaseIdiomsURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callCheckRenew = createAsyncThunk(checkRenewURL, async (body) => {
	try {
		const response = await postRequest({ url: checkRenewURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callCheckContractNumber = createAsyncThunk(checkContractNumberURL, async (body) => {
	try {
		const response = await postRequest({ url: checkContractNumberURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetCommissionDetails = createAsyncThunk(commissionDetailURL, async (body) => {
	try {
		const response = await postRequest({ url: commissionDetailURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetCommissionDetailsByAgentId = createAsyncThunk(commissionDetailByAgentIdURL, async (body) => {
	try {
		const response = await postRequest({ url: commissionDetailByAgentIdURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetCommissionDetailsSelect = createAsyncThunk(commissionDetailByPayoutIdURL, async (body) => {
	try {
		const response = await postRequest({ url: commissionDetailByPayoutIdURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callApproveCommission = createAsyncThunk(approveDetailURL, async (body) => {
	try {
		const response = await postRequest({ url: approveDetailURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetCommissionPayout = createAsyncThunk(commissionPayoutURL, async (body) => {
	try {
		const response = await postRequest({ url: commissionPayoutURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const createCommissionPayout = createAsyncThunk(createCommissionPayoutURL, async (body) => {
	try {
		const response = await postRequest({ url: createCommissionPayoutURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const approveOrRejectCommissionPayout = createAsyncThunk(approveOrRejectCommissionPayoutURL, async (body) => {
	try {
		const response = await postRequest({ url: approveOrRejectCommissionPayoutURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const pdf = createAsyncThunk(getPaymentDDURL, async (body) => {
	try {
		const response = await postRequest({ url: getPaymentDDURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetPaymentDetailByContractNumber = createAsyncThunk(getPaymentDetailURL, async (body) => {
	try {
		const response = await postRequest({ url: getPaymentDetailURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callGetUserContracts = createAsyncThunk(

	getUserContractsURL,
	async (body) => {
		try {
			const response = await postRequest({
				url: getUserContractsURL,
				data: body,
			});
			return response;
		} catch (error) {
			throw error;
		}
	}

);

export const callSearchContractsForUser = createAsyncThunk(

	searchContractsForUserURL,
	async (body) => {
		try {
			const response = await postRequest({
				url: searchContractsForUserURL,
				data: body,
				showLoading: false,
				showAlert: false,
			});
			return response;
		} catch (error) {
			throw error;
		}
	}

);

export const callAttachContractToUser = createAsyncThunk(

	attachContractToUserURL,
	async (body) => {
		try {
			const response = await postRequest({
				url: attachContractToUserURL,
				data: body,
			});
			return response;
		} catch (error) {
			throw error;
		}
	}

);

export const callDetachContractFromUser = createAsyncThunk(

	detachContractFromUserURL,
	async (body) => {
		try {
			const response = await postRequest({
				url: detachContractFromUserURL,
				data: body,
			});
			return response;
		} catch (error) {
			throw error;
		}
	}

);